import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { useEffect, useMemo, useRef, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { useDarkTheme } from "@/contexts/DarkTheme";
import { cn } from "@/lib/utils";
import debounce from "lodash/debounce";
import { useTranslation } from "next-i18next";
import { BiSolidHelpCircle } from "react-icons/bi";
import { CgArrowBottomRight, CgArrowTopRight } from "react-icons/cg";
import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";
import Slider from "react-slick";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { toast } from "@/components/ui/use-toast";
import { API_URL, POLYGON_IO_URL } from "@/config";
import {
  formatMoney,
  formatToDecimalPlaces,
  getIsFxStrategy,
  getLogos,
  Pagination,
  randomString,
} from "@/helpers/helperFunctions";
import { SharpRatioString } from "@/helpers/types";
import ViewModal from "@/sections/build/components/StrategyViewModal";
import { ExternalLinkIcon, Eye, Layers2 } from "lucide-react";
import { useRouter } from "next/router";
// import { PIOAggregates } from "@/config/polygon-constants";
import Loader from "@/components/Loader";
import { PIO_CONST, SIOSubscription } from "@/config/polygon-constants";
import Link from "next/link";
import { io } from "socket.io-client";
import { usePostMarketplaceFilterStrategies } from "@/api/marketPlaceApi";
import { useGetSymbolData, useGetTickerSnapshot } from "@/api/symbolApi";
import { usePostCopyStrategy } from "@/api/strategyApi";
import SymbolUpdateModal from "@/components/common/SymbolUpdateModal";
import { Button } from "@/components/ui/button";
import { Label } from "@radix-ui/react-label";
const isForex = true;
const filters = {
  asset_class: "forex",
  sort_order: "top_and_win_desc",
  win_p: "",
  SR: "",
  copiers: "",
  timeframe: "",
  sl_range: "",
  tp_range: "",
  exit: "",
  action: "",
};

const index = () => {
  let [page, setPage] = useState(1);
  // let [pageAuthors, setPageAuthors] = useState(1);
  let [dataSize, setDatasize] = useState(5);
  let [pages, setPages] = useState(0);
  // let [pagesAuthors, setPagesAuthors] = useState(0);
  let [totalDataLength, setTotalDataLength] = useState(0);
  // let [totalDataLengthAuthors, setTotalDataLengthAuthors] = useState(0);
  let [symbols, setSymbols] = useState([]);
  // let [dataAuthors, setDataAuthors] = useState([]);
  let [loading, setLoading] = useState<boolean>(false);
  // let [loadingAuthors, setLoadingAuthors] = useState<boolean>(false);
  const [logos, setLogos] = useState<any>(new Map());
  const { t } = useTranslation("build");
  const { darkTheme } = useDarkTheme();
  const [userInfo, setUserInfo]: any = useState({});
  const settings = {
    className: "variable-width",
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 500,
    initialSlide: 0,
    infinite: false,
  };
  const router = useRouter();

  const formData = Object.entries(filters).reduce((fd, [key, value]) => {
    if (value !== undefined && value !== null) fd.append(key, value);
    return fd;
  }, new FormData());
  const polygonSocket = useMemo(() => io(POLYGON_IO_URL), []);
  const [selected, setSelected] = useState<any>({});
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showSymbolUpdateModal, setShowSymbolUpdateModal] =
    useState<boolean>(false);
  const [currentCopyStrategy, setCurrentCopyStrategy] = useState<any>(null);

  let [livePriceData, setLivePriceData]: any = useState({});
  const pioDataRef = useRef<string[]>([]);

  const {
    data,
    isLoading: isLoadingFilterStrategies,
    isSuccess: isSuccessFilterStrategies,
  } = usePostMarketplaceFilterStrategies(
    formData,
    String(page),
    String(dataSize)
  );

  const {
    data: tickerSnapshot,
    isLoading: isLoadingTickerSnapShot,
    isSuccess: isSuccessTickerSnapShot,
  } = useGetTickerSnapshot(symbols.toString());

  const {
    mutateAsync: copyStrategy,
    data: copyStrategyData,
    isSuccess: isCopySuccess,
    isPending: isCopyPending,
  } = usePostCopyStrategy();

  const { mutateAsync: getSymbolData, isPending: isCurrentPriceLoading } =
    useGetSymbolData();

  useEffect(() => {
    if (isSuccessFilterStrategies && data) {
      setTotalDataLength(data.data.total);
      setPages(data.data.pages);
      if (data?.data) {
        let symbols = data?.data?.items;
        let finalData: any = symbols.map((each: any) => each?.strategy?.symbol);
        setSymbols(finalData);
        getLogos(finalData, setLogos);
      }
    }
  }, [isSuccessFilterStrategies, data, isLoadingFilterStrategies]);

  useEffect(() => {
    if (isSuccessTickerSnapShot && tickerSnapshot) {
      setLivePriceData(tickerSnapshot?.data);
    }
  }, [isSuccessTickerSnapShot, tickerSnapshot, isLoadingTickerSnapShot]);

  useEffect(() => {
    if (isCopySuccess && copyStrategyData) {
      toast({
        title: t("Strategy copied successfully"),
        variant: "default",
      });
      setTimeout(() => {
        router.push(
          "/edit-strategy/" +
            encodeURIComponent(userInfo?.user_id) +
            "/" +
            copyStrategyData?.data?.id +
            randomString(5) +
            "/" +
            userInfo.token +
            "/false" +
            `?ref=${router.asPath}&locale=${router.query.locale || "en"}`
        );
      }, 2000);
    }
  }, [isCopySuccess, tickerSnapshot, isCopyPending]);

  useEffect(() => {
    if (typeof window !== undefined) {
      const u = JSON.parse(localStorage.getItem("user-info")!);
      setUserInfo(u);
    }
  }, []);

  useEffect(() => {
    pioDataRef.current = symbols;
  }, [symbols]);

  useEffect(() => {
    const handleSocketData = (topic: string, data: any, oldData: any) => {
      if (Object.keys(oldData).includes(data.pair)) {
        let updatedLiveData = { ...oldData };
        let updatedStock = updatedLiveData[data.pair];
        updatedStock.lastQuote.p = data.c;
        setLivePriceData((prev: any) => {
          const updatedData = { ...prev };
          updatedData[data.pair] = updatedStock;
          return updatedData;
        });
      }
    };
    let handleConnect = () => {
      polygonSocket.emit(PIO_CONST.EVENT_NAME.SUBSCRIBE, {
        symbols: pioDataRef.current,
        type: PIO_CONST.SUBS_TYPE.FMV,
      } as SIOSubscription);
      polygonSocket.emit(PIO_CONST.EVENT_NAME.SUBSCRIBE, {
        symbols: pioDataRef.current,
        type: PIO_CONST.SUBS_TYPE.BLOFIN,
      } as SIOSubscription);
      polygonSocket.emit(PIO_CONST.EVENT_NAME.SUBSCRIBE, {
        symbols: pioDataRef.current,
        type: PIO_CONST.SUBS_TYPE.AGGREGATOR_FX,
      } as SIOSubscription);
    };
    polygonSocket.on("connect", handleConnect);

    polygonSocket.on(PIO_CONST.SUBS_TOPICS.FMV, (data: any) =>
      handleSocketData(PIO_CONST.SUBS_TOPICS.FMV, data, livePriceData)
    );
    polygonSocket.on(PIO_CONST.SUBS_TOPICS.AGGREGATOR_FX, (data: any) =>
      handleSocketData(PIO_CONST.SUBS_TOPICS.AGGREGATOR_FX, data, livePriceData)
    );
    polygonSocket.on(PIO_CONST.SUBS_TOPICS.AGGREGATOR_CRYPTO, (data: any) =>
      handleSocketData(
        PIO_CONST.SUBS_TOPICS.AGGREGATOR_CRYPTO,
        data,
        livePriceData
      )
    );

    return () => {
      polygonSocket.off(PIO_CONST.SUBS_TOPICS.FMV);
      polygonSocket.off(PIO_CONST.SUBS_TOPICS.AGGREGATOR_FX);
      polygonSocket.off(PIO_CONST.SUBS_TOPICS.AGGREGATOR_CRYPTO);
    };
  }, [livePriceData]);

  const copyHandler = async (item: any, userId: string) => {
    if (!userId) {
      toast({
        title: t("Login Required"),
        description: t("Please log in to copy this strategy."),
        variant: "destructive",
      });
      return;
    }
    try {
      const res = await getSymbolData({
        user_id: userId,
        ticker: item?.strategy.symbol,
      });
      if (!res?.data || res?.data?.regularMarketPrice == 0) {
        setShowSymbolUpdateModal(true);
        setCurrentCopyStrategy(item?.strategy);
      } else {
        await copyStrategy({ userId, key: item?.strategy.keygen });
      }
    } catch (error) {
      toast({
        title: t("Error copying strategy"),
        variant: "destructive",
      });
    }
  };
  return (
    <>
      <ViewModal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        selected={selected}
        token={userInfo?.token}
      />
      <SymbolUpdateModal
        isOpen={showSymbolUpdateModal}
        strategy={currentCopyStrategy}
        setIsOpen={setShowSymbolUpdateModal}
      ></SymbolUpdateModal>
      <Card>
        <CardHeader className="flex !p-3 px-6 justify-between flex-row items-center w-full">
          <CardTitle className="text-xl flex gap-2 items-center text-nowrap">
            Top Strategies
          </CardTitle>

          <Link
            href="/marketplace"
            className="flex text-xs hover:underline text-[var(--marketplace-blue-new)] font-medium"
          >
            Explore More <ExternalLinkIcon className="h-[15px]" />
          </Link>
        </CardHeader>
        {isLoadingFilterStrategies ||
        (data && data?.data?.items.length) == 0 ? (
          !loading ? (
            <div className="w-full flex items-center justify-center h-[200px]">
              No data found
            </div>
          ) : (
            <div className="w-full flex items-center justify-center h-[200px]">
              <Loader />
            </div>
          )
        ) : (
          <CardContent className={`p-3 pt-0 w-full h-[500px] overflow-auto`}>
            {data?.data?.items?.map((item: any, index: number) => {
              let badges = [
                item?.meta_data?.strategy_meta.actions,
                item?.meta_data?.strategy_meta.datas,
                item?.meta_data?.strategy_meta.indicators,
                item?.meta_data?.strategy_meta.logics,
              ].reduce((acc, curr) => {
                return acc.concat(curr);
              }, []);
              const canvasData = item?.strategy?.canvas_data
                ? JSON.parse(item?.strategy?.canvas_data)
                : {};
              const nodes = canvasData?.filter?.(
                (item: any) => item.type === "selectorNode"
              );
              const edges = canvasData?.filter?.(
                (item: any) => item.type === "buttonedge"
              );
              const isFxStartegy = !getIsFxStrategy(item?.strategy?.symbol);
              const currentPrice =
                livePriceData[item?.strategy?.symbol]?.lastQuote?.p ||
                livePriceData[item?.strategy?.symbol]?.lastQuote?.a ||
                0;
              let todaysChange =
                livePriceData[item?.strategy?.symbol]?.todaysChange;
              if (todaysChange !== "-") {
                todaysChange = todaysChange?.toFixed(2);
              }
              let percentageChange =
                livePriceData[item?.strategy?.symbol]?.todaysChangePerc;
              if (percentageChange !== "-") {
                percentageChange = percentageChange?.toFixed(2);
              }

              let isPositive = todaysChange >= 0;

              let category = Object.keys(
                item?.meta_data?.strategy_meta?.indicator_category
              ).join(", ");
              let maxTakeProfit = item?.meta_data?.tpsl?.take_profit_p_max;
              let stopLoss = item?.meta_data?.tpsl?.stop_loss_p_max;
              let actions: any = new Set(
                item?.meta_data?.strategy_meta?.actions
              );
              actions = Array.from(actions);
              let actionOptions: any = {
                Buy: "Long",
                Sell: "Short",
                "Smart Buy": "Smart Buy",
                "Smart Sell": "Smart Sell",
                "Smart Exit Position": "Smart Exit",
              };
              return (
                <Card
                  key={item?.strategy?.symbol + "_" + index}
                  className={cn("h-fit", index != 0 ? "mt-2" : "")}
                >
                  <CardHeader className={`p-4`}>
                    <div className="flex flex-col sm:flex-row">
                      <div className="flex flex-col justify-between">
                        <CardTitle className="text-md flex items-center gap-2">
                          {logos?.get(item.symbol) !== undefined ? (
                            <img
                              src={logos.get(item.symbol)}
                              style={{
                                maxHeight: "30px",
                                maxWidth: "30px",
                              }}
                              alt={item.strategy.symbol}
                            />
                          ) : (
                            <img
                              src={
                                darkTheme
                                  ? "/images/logos/Symbol_Dark.png"
                                  : "/images/logos/Symbol_Light-30.png"
                              }
                              style={{
                                maxHeight: "30px",
                                maxWidth: "30px",
                              }}
                              alt={item.strategy.symbol}
                            />
                          )}
                          <div className="text-muted-foreground">
                            {item.strategy.symbol}
                          </div>

                          <div className="pl-1 text-[12px] text-muted-foreground">
                            {item.strategy.timeframe}
                          </div>
                        </CardTitle>
                        {category && (
                          <div className="bg-[--marketplace-blue-new] rounded-xl text-[10px] p-[2px] pl-2 pr-2 mt-2 mb-2 sm:mt-0 sm:mb-0 text-white max-w-fit">
                            {category}
                          </div>
                        )}
                      </div>

                      <div className="flex items-end sm:ml-[5%] gap-3">
                        <div className="flex flex-col  gap-1 ">
                          {item?.backtest_data?.win >= 75 ? (
                            <div className="text-3xl font-semibold text-[--marketplace-green]">
                              {formatToDecimalPlaces(
                                item?.backtest_data?.win,
                                0
                              )}
                              %
                            </div>
                          ) : item?.backtest_data?.win >= 50 ? (
                            <div className="text-3xl font-semibold text-[--marketplace-blue]">
                              {formatToDecimalPlaces(
                                item?.backtest_data?.win,
                                0
                              )}
                              %
                            </div>
                          ) : item?.backtest_data?.win >= 0 ? (
                            <div className="text-3xl font-semibold text-[--marketplace-red]">
                              {formatToDecimalPlaces(
                                item?.backtest_data?.win,
                                0
                              )}
                              %
                            </div>
                          ) : (
                            "NA"
                          )}

                          <div className="flex items-center gap-0.5 text-[11px] text-[var(--marketplace-grey)] font-semibold">
                            Average Win
                          </div>
                        </div>
                        {actions.length > 0 && (
                          <div className="flex flex-col  gap-1 ">
                            <div className="flex text-sm font-semibold">
                              {actions.map((each: string, index: string) => {
                                if (actionOptions[each] === "Long") {
                                  return (
                                    <div
                                      className="text-foreground text-green-foreground flex items-end"
                                      key={each + "_" + index}
                                    >
                                      {actionOptions[each]}{" "}
                                      <CgArrowTopRight className="text-sm" />
                                    </div>
                                  );
                                }

                                if (actionOptions[each] === "Short") {
                                  return (
                                    <div
                                      className="text-foreground text-red-foreground flex items-end"
                                      key={each + "_" + index}
                                    >
                                      {actionOptions[each]}{" "}
                                      <CgArrowBottomRight className="text-sm" />
                                    </div>
                                  );
                                }

                                if (actionOptions[each] === "Smart Buy") {
                                  return (
                                    <div
                                      className="text-foreground text-green-foreground flex items-end"
                                      key={each + "_" + index}
                                    >
                                      {actionOptions[each]}{" "}
                                      <FaArrowTrendUp className="text-sm" />
                                    </div>
                                  );
                                }
                                if (actionOptions[each] === "Smart Sell") {
                                  return (
                                    <div
                                      className="text-foreground text-red-foreground flex items-end"
                                      key={each + "_" + index}
                                    >
                                      {actionOptions[each]}{" "}
                                      <FaArrowTrendDown className="text-sm ml-[2px]" />
                                    </div>
                                  );
                                }
                              })}
                            </div>
                            <div className="flex text-[11px] items-center gap-0.5 text-[var(--marketplace-grey)] font-semibold">
                              {t("Actions")}
                            </div>
                          </div>
                        )}
                        {maxTakeProfit >= 0 && (
                          <div className="flex flex-col  gap-1 text-xs">
                            <div className=" text-green-foreground text-sm font-semibold">
                              {maxTakeProfit}%
                            </div>
                            <div className="flex items-center gap-0.5 text-[11px] text-[var(--marketplace-grey)] font-semibold">
                              {t("Take Profit")}
                            </div>
                          </div>
                        )}
                        {stopLoss >= 0 && (
                          <div className="flex flex-col gap-1 text-xs">
                            <div className=" text-red-foreground text-sm font-semibold">
                              {stopLoss}%
                            </div>
                            <div className="flex items-center gap-0.5 text-[11px] text-[var(--marketplace-grey)] font-semibold">
                              {t("Stop Loss")}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent className={`p-4 pt-2 flex flex-col gap-3`}>
                    <div className="border-b flex flex-col gap-2 pb-2">
                      <div className="flex items-center relative mb-3">
                        <div className="text-sm text-muted-foreground font-bold">
                          {t("Statistics")}
                        </div>
                        <div className="w-[70%] absolute right-6 top-0 bottom-0">
                          <Slider {...settings}>
                            {badges?.map((item: any, id: number) => {
                              return (
                                <div className="mr-2" key={id}>
                                  <Badge variant="outline">{item}</Badge>
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                      </div>

                      <div className="flex text-xs gap-6">
                        <div className="flex flex-col gap-1">
                          <div className="flex gap-0.5 text-[var(--marketplace-grey)] font-semibold">
                            {t("Drawdown")}{" "}
                            <HoverCard>
                              <HoverCardTrigger>
                                <BiSolidHelpCircle size={16} />
                              </HoverCardTrigger>
                              <HoverCardContent>
                                {t(
                                  "How much your strategy drops from its highest point to its lowest to measure risk - smaller drops mean less risk, bigger drops mean more risk."
                                )}
                              </HoverCardContent>
                            </HoverCard>
                          </div>
                          <div
                            className={
                              item?.backtest_data?.dd > 0
                                ? "text-[var(--foreground-green)]"
                                : item?.backtest_data?.dd < 0
                                ? "text-[var(--foreground-red)]"
                                : ""
                            }
                          >
                            ${formatMoney(item?.backtest_data?.dd, 2, "N/A", 2)}
                          </div>
                        </div>
                        <div className="flex flex-col  gap-1">
                          <div className="flex  gap-0.5 text-[var(--marketplace-grey)] font-semibold">
                            {t("Sharpe Ratio")}
                            <HoverCard>
                              <HoverCardTrigger>
                                <BiSolidHelpCircle size={16} />
                              </HoverCardTrigger>
                              <HoverCardContent className="flex flex-col gap-1">
                                {t(
                                  "The risk-adjusted return of your strategy, helping you assess the quality of your trading strategy overall."
                                )}
                                <span>
                                  {t(
                                    "<1: Poor – Returns are not compensating for the risk taken."
                                  )}
                                </span>
                                <span>
                                  {t(
                                    "1: Good – Acceptable risk-adjusted returns."
                                  )}
                                </span>
                                <span>
                                  {t(
                                    "2: Very Good – Strong performance with solid risk management."
                                  )}
                                </span>
                                <span>
                                  {t(
                                    ">3: Excellent – Exceptional risk-adjusted returns."
                                  )}
                                </span>
                              </HoverCardContent>
                            </HoverCard>
                          </div>
                          <div
                            className={cn(
                              "",
                              item?.backtest_data?.sr ===
                                SharpRatioString.BELOW3
                                ? "text-red-foreground"
                                : item?.backtest_data?.sr ===
                                  SharpRatioString.ABOVE3
                                ? "text-green-foreground"
                                : "text-foreground"
                            )}
                          >
                            {item?.backtest_data?.sr}
                          </div>
                        </div>

                        {!!currentPrice && (
                          <div className="flex  flex-col gap-1">
                            <div className="flex gap-0.5 text-[11px] text-[var(--marketplace-grey)] font-semibold">
                              Current Price
                            </div>

                            {!isLoadingTickerSnapShot && (
                              <div className="flex items-end">
                                <div>
                                  {currentPrice &&
                                    Number(currentPrice)?.toFixed(2)}
                                </div>
                                {todaysChange !== "-" && (
                                  <div
                                    className={`ml-1 ${
                                      isPositive
                                        ? "text-[var(--foreground-green)]"
                                        : "text-[var(--foreground-red)]"
                                    }`}
                                  >
                                    ({percentageChange}
                                    %)
                                  </div>
                                )}
                              </div>
                            )}
                            {isLoadingTickerSnapShot && (
                              <div className="">
                                <Loader />
                              </div>
                            )}
                          </div>
                        )}

                        <div className="flex flex-col  gap-1">
                          <div className="flex gap-0.5 text-[var(--marketplace-grey)] font-semibold">
                            Copier Count
                          </div>
                          <div className="text-foreground">
                            {item?.meta_data?.copiers_count}
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                  <CardFooter className={`flex justify-between pb-4`}>
                    <Label className="text-muted-foreground font-semibold">
                      {item?.strategy?.strategy_name}
                    </Label>
                    <div className="flex gap-2">
                      <div
                        className="mr-2 text-sm font-bold cursor-pointer text-muted-foreground hover:text-[#545454]"
                        onClick={() => {
                          setSelected({
                            nodes,
                            edges,
                            symbol: item.strategy.symbol,
                            timeframe: item.strategy.timeframe,
                          });
                          setShowModal(true);
                        }}
                      >
                        <div className="flex items-center">
                          <div>
                            <Eye className="w-[15px]" />
                          </div>
                          <div className="ml-1">{t("View")}</div>
                        </div>
                      </div>
                      {/* //replace it is forex strategy to disable when forex */}
                      {true ? (
                        <Button
                          loading={isCopyPending || isCurrentPriceLoading}
                          variant={"ghost"}
                          className="text-sm font-bold cursor-pointer text-muted-foreground hover:text-[#545454] h-auto p-0 m-0"
                          onClick={() => {
                            copyHandler(item, userInfo?.user_id);
                          }}
                        >
                          <div className="flex items-center">
                            <div>
                              <Layers2 className="w-[15px]" />
                            </div>
                            <div className="ml-1">{t("Copy")}</div>
                          </div>
                        </Button>
                      ) : (
                        <HoverCard>
                          <HoverCardTrigger>
                            <div className="text-sm font-bold cursor-pointer text-muted hover:text-[#545454]">
                              <div className="flex items-center">
                                <div>
                                  <Layers2 className="w-[15px]" />
                                </div>
                                <div className="ml-1">{t("Copy")}</div>
                              </div>
                            </div>
                          </HoverCardTrigger>
                          <HoverCardContent className="w-40">
                            {t(
                              "This asset class is not currently accessible for your account"
                            )}
                          </HoverCardContent>
                        </HoverCard>
                      )}
                    </div>
                  </CardFooter>
                </Card>
              );
            })}

            <div className="mt-3">
              <Pagination
                totalCount={totalDataLength}
                currentPage={page}
                changePage={setPage}
                limit={dataSize}
              />
            </div>
          </CardContent>
        )}
      </Card>
    </>
  );
};

export default index;
